import { Component, OnInit, Input } from '@angular/core';
import { FeedbackProvider } from '../feedbackProvider'
import {MatSnackBar} from '@angular/material';
import { Router } from '@angular/router';
@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {

	@Input('email') email:boolean = false
  @Input('component') component:string = ''

  public assitence:{
  	type: any,
  	subject: any,
  	email: any,
  	user_id: any,
  	note: any
  }

  typeFeedback:any
  device_info:any
  profile: any
  disabled: boolean = false

  constructor(
    public feedbackService: FeedbackProvider,
    public snackBar: MatSnackBar,
    private router: Router
    ) {
      this.profile= JSON.parse( localStorage.getItem('userInfo'))
      console.log(this.profile);

  	  this.assitence={
        type: '',
        subject: '',
        email: this.profile ? this.profile.email : '',
        user_id: this.profile ? this.profile.rol_id : '',
        note: ''
      }
      this.device_info  = {
        device: 'mobile',
        device_model: null,
        device_os: null,
        device_os_version: null,
        navigator: 'Codova'
      }
      if(this.router.url === '/'){
        this.router.navigate(['login'])
      }
  }

  ngOnInit() {
  	this.feedbackService.getFeedBackType().subscribe((response:any)=>{
  		if (response.success) {
  			this.typeFeedback=response.data
  		}
  	})
  }


  goSendFeedBack(){
    this.disabled = true
    let feedback_data = {
          type_feedback_id: this.assitence.type,
          subject: this.assitence.subject,
          user_id: this.assitence.user_id ? this.assitence.user_id: 1,
          msg: this.assitence.note,
          email: this.assitence.email,
          path_module: this.component,
          /*device: 'Navegador',
          device_os: 'OSX',
          device_os_version: '2.6'*/
          device: this.device_info.device,
          device_os: this.device_info.device_os,
          device_os_version: this.device_info.device_os_version
      }
      this.feedbackService.setFeedBack(feedback_data).subscribe( (res:any) => {
      this.disabled=false
        if(res.success){
          this.showMsg('Tu solitud fue enviada correctamente')
          this.assitence = { type: '', subject: '' ,email: '' , note: '' , user_id: 0};
        }else{
          this.showMsg('Algo salio mal')
        }
      })
  }

  showMsg(msg=''){
    this.snackBar.open(
      msg,
      'Cerrar',
      { duration: 2000 }
    );
  }
}
